import { EcommerceAPIApi as EcommerceApi } from '@parkingbase/ecommerce-api-dev';

import { BaseApiService } from './baseApi.service';

export class ParkingHistoryService extends BaseApiService {
  protected parkingHistoryApi: EcommerceApi;

  constructor() {
    super();
    this.parkingHistoryApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getParkingHistory() {
    const response = await this.parkingHistoryApi.getParkingHistory();
    return response.data;
  }

  async getMonthlyHistory() {
    const response = await this.parkingHistoryApi.getMonthlyHistory();
    return response.data;
  }

  async getTransientReceipt(parkingHistoryId: string) {
    const response = await this.parkingHistoryApi.getParkingHistoryTicketReceipt(parkingHistoryId, {
      responseType: 'blob',
    });
    return response.data;
  }

  async getMonthlyReceipt(company: string, transactionId: string) {
    const response = await this.parkingHistoryApi.getMonthlyHistoryTicketReceipt(
      company,
      transactionId,
      { responseType: 'blob' }
    );
    return response.data;
  }
}
